import React, { useState } from 'react';
import { FaArrowRight } from 'react-icons/fa';

const GetInTouch = () => {
    const [ copySuccess, setCopySuccess ] = useState('Copy Email');

    const copyToClipboard = (e) => {
        navigator.clipboard.writeText('Lukabaramishvili@gmail.com');
        setCopySuccess('Copied!');
        setTimeout(() => {
            setCopySuccess('Copy Email');
        }, 5000);
    };

    return (
        <>
        <div className='get-in-touch'>
            <a className='email-link' href={"mailto:Lukabaramishvili@gmail.com"}><FaArrowRight /> Get in Touch</a>
        </div>
        <div className='copy-clipboard'>
            <button onClick={copyToClipboard}>{copySuccess}</button>
        </div>
        </>
    )
}

export default GetInTouch;
